var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24h24V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.722 5.315a1 1 0 10-1.459 1.367l4.059 4.32H6a1 1 0 100 1.997h9.322l-4.059 4.319a1 1 0 101.459 1.367L19.002 12l-6.28-6.685z",
    fill: "#231815"
  }))));
}

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Ctitle%3E7D883C6D-6C43-4F53-9C16-C9E331603E7A%3C/title%3E %3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='Group'%3E %3Cpolygon id='Bound' points='0 24 24 24 24 0 0 0'%3E%3C/polygon%3E %3Cpath d='M12.722,5.31477059 C12.344,4.91323332 11.711,4.89325634 11.308,5.26982239 C10.906,5.64738729 10.885,6.27965867 11.263,6.6821948 L15.322,11.0012176 L6,11.0012176 C5.448,11.0012176 5,11.448702 5,12.0000666 C5,12.5524301 5.448,12.9989155 6,12.9989155 L15.322,12.9989155 L11.263,17.3179384 C10.885,17.7204745 10.906,18.3527459 11.308,18.7303108 C11.501,18.9101036 11.747,19 11.993,19 C12.259,19 12.525,18.8951209 12.722,18.6853626 L19.002,12.0000666 L12.722,5.31477059 Z' id='Color' fill='%23231815'%3E%3C/path%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgIcNext as ReactComponent };